export const KELLER_STATIC_URL = process.env.REACT_APP_KELLER_STATIC_URL || '';
export const KELLER_MEDIA_URL = process.env.REACT_APP_KELLER_MEDIA_URL || '';
